import Vue from 'vue'
import Router from 'vue-router'
import routeGuard from '@/router/guards'
import routes from '@/router/routes'

// Ensure Router is only installed once
let installed = false
if (!installed) {
  Vue.use(Router)
  installed = true
}

const router = new Router({
  mode: 'history',
  base: '/profile',
  routes,
  scrollBehavior() {
    // ensure we are at the top of the new page
    return { x: 0, y: 0 }
  }
})

router.beforeEach(routeGuard)

export default router
